import { Component,PLATFORM_ID ,Inject, HostListener } from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet,Router } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

// Material
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

// Paginas
import { StatisticsComponent } from './screens/statistics/statistics.component';
import { SummaryComponent } from './screens/summary/summary.component';
import { ReadabilityComponent } from './screens/readability/readability.component';
import { TextBoxComponent } from './text-box/text-box.component';
import { ErrorsComponent } from './screens/errors/errors.component';
import { LexicalDiversityComponent } from './screens/lexical-diversity/lexical-diversity.component';
import { TaggerComponent } from './screens/tagger/tagger.component';
import { KvlComponent } from './screens/vocabulary/kvl/kvl.component';
import { EvpComponent } from './screens/vocabulary/evp/evp.component';
import { CocaComponent } from './screens/vocabulary/coca/coca.component';
import { AwlComponent } from './screens/vocabulary/awl/awl.component';
import { MetadiscourseComponent } from './screens/metadiscourse/metadiscourse.component';
import { ScorecardComponent } from './screens/scorecard/scorecard.component';
import { DashboardComponent } from './screens-top/dashboard/dashboard.component';
import { ProfileComponent } from './screens-top/profile/profile.component';
import { ApiUpdateComponent } from './screens-top/api-update/api-update.component';
import { NewAnalysisComponent } from './screens-top/new-analysis/new-analysis.component';
import { GlobalExportComponent } from './screens-top/global-export/global-export.component';

// Paginas sin Login
import { TextBoxFreeComponent } from './screens-free/text-box-free/text-box-free.component';
import { SummaryFreeComponent } from './screens-free/summary-free/summary-free.component';
import { StatisticsFreeComponent } from './screens-free/statistics-free/statistics-free.component';
import { ReadabilityFreeComponent } from './screens-free/readability-free/readability-free.component';
import { ErrorsFreeComponent } from './screens-free/errors-free/errors-free.component';
import { LexicalFreeComponent } from './screens-free/lexical-free/lexical-free.component';
import { TaggerFreeComponent } from './screens-free/tagger-free/tagger-free.component';
import { EvpFreeComponent } from './screens-free/evp-free/evp-free.component';
import { KvlFreeComponent } from './screens-free/kvl-free/kvl-free.component';
import { CocaFreeComponent } from './screens-free/coca-free/coca-free.component';
import { AwlFreeComponent } from './screens-free/awl-free/awl-free.component';
import { MetadiscourseFreeComponent } from './screens-free/metadiscourse-free/metadiscourse-free.component';
import { ScorecardFreeComponent } from './screens-free/scorecard-free/scorecard-free.component';

import { ProyectosService } from './services/proyectos.service';

import {AnalysisServiceService } from './services/analysis-service/analysis-service.service';

import {SaveConfirmationComponent } from './tools/save-confirmation/save-confirmation.component';

import { environment } from "../../src/environments/environment"
import { FacadeService } from './services/facade.service';
import { HttpClient, HttpHeaders } from "@angular/common/http"
import { UsuarioService } from './services/usuario.service';

import {BlockedModalComponent } from './tools/blocked-modal/blocked-modal.component';

import { ProjectRemoveComponent } from './tools/project-remove/project-remove.component';


//Variables del Navegador
type MenuItem = 'summary' | 'statistics' | 'readability' | 'errors' | 'lexicalDiversity' | 'tagger' | 'kvl' | 'evp' | 'coca' | 'awl' | 'metadiscourse' | 'scorecard' | 'dashboard' | 'profile' | 'apiplan' | 'summaryfree' | 'statisticsfree' | 'readabilityfree' | 'errorsfree' | 'lexicalfree' | 'taggerfree' | 'scorecardfree' | 'evpfree' | 'kvlfree' | 'cocafree' | 'awlfree' | 'metadiscoursefree';

//Variable para expandir cada cuadro
interface ExpandedState {
  [key: string]: boolean;
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    MatDialogModule,
    CommonModule,
    RouterOutlet,
    HttpClientModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    StatisticsComponent,
    SummaryComponent,
    ReadabilityComponent,
    TextBoxComponent,
    ErrorsComponent,
    LexicalDiversityComponent,
    TaggerComponent,
    KvlComponent,
    EvpComponent,
    CocaComponent,
    AwlComponent,
    MetadiscourseComponent,
    ScorecardComponent,
    DashboardComponent,
    ProfileComponent,
    ApiUpdateComponent,
    NewAnalysisComponent,
    GlobalExportComponent,
    SaveConfirmationComponent,
    TextBoxFreeComponent,
    SummaryFreeComponent,
    StatisticsFreeComponent,
    ReadabilityFreeComponent,
    ErrorsFreeComponent,
    LexicalFreeComponent,
    TaggerFreeComponent,
    EvpFreeComponent,
    KvlFreeComponent,
    CocaFreeComponent,
    AwlFreeComponent,
    MetadiscourseFreeComponent,
    ScorecardFreeComponent,
    ProjectRemoveComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})



export class AppComponent {
  title = 'app-text-inspector';
  username = 'Michael';
  readonly upgradeApiSubscribePath = '/upgrade-api-subcribe';
  readonly loginUrl = `${environment.text_wp.replace(/\/$/, '')}/wplogin`;
  readonly konamiCode = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
  private konamiBuffer: string[] = [];
  showKonamiThanks = false;
  selectedMenuItem: string = 'dashboard'; //Variable por default muestra esta pestaña
  newAnalysis: boolean = false;
  private readonly newAnalysisReturnMenuKey = 'new_analysis_return_menu';
  private readonly newAnalysisReturnableMenus = new Set<string>([
    'summary',
    'statistics',
    'readability',
    'errors',
    'lexicalDiversity',
    'tagger',
    'kvl',
    'evp',
    'coca',
    'awl',
    'metadiscourse',
    'scorecard',
    'summaryfree',
    'statisticsfree',
    'readabilityfree',
    'errorsfree',
    'lexicalfree',
    'taggerfree',
    'scorecardfree',
    'evpfree',
    'kvlfree',
    'cocafree',
    'awlfree',
    'metadiscoursefree',
  ]);
  public version: any;
  
  textUID: string | null = '';
  englishType: string = 'british';//Variable de tipo de Ingles para cambiar la pestaña

  checked: boolean = true; //Variable del mat-slide-toggle del text-component

  isExpandedDialog = false;//Variable para expandir el recuadro de Analysis Options

  fisrtProject: boolean= true; //Variable que es true cada que se inica el componente para el bloqueo de las pestañas

  isTextBoxDisabled: boolean = false;
  isTextInputDisabled: boolean = false;

  isLogin: boolean = true;
  isEVPFlag: boolean = false;

  isCreatingProject: boolean = false;

  textFile: string;
  showBdelete: boolean;

  currentAnalysisMode: string; 
  currentSplitCharacter: string;

  loaderClearServers: boolean;

  valueM: boolean;
  valueTM: boolean;
  valueLimitProjects:boolean;
  valueLimitWords:boolean;
  valueEditCategory:boolean;
  stringEditCategory:String;

  valueLimitProfileUsers:boolean = false;

  valueMessageProfileOrg:boolean = false;
  messageProfileOrg:string;

  wordsLimit: any;

  showPaymentModal = false;

  get isUpgradeApiSubscribeRoute(): boolean {
    return this.router.url.split('?')[0] === this.upgradeApiSubscribePath;
  }

  refreshPage() {
    window.location.reload();
  }

  @HostListener('window:keydown', ['$event'])
  handleKonamiCode(event: KeyboardEvent): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (this.showKonamiThanks && event.key === 'Escape') {
      this.closeKonamiThanks();
      return;
    }

    const key = event.key.length === 1 ? event.key.toLowerCase() : event.key;
    this.konamiBuffer.push(key);

    if (this.konamiBuffer.length > this.konamiCode.length) {
      this.konamiBuffer.shift();
    }

    const codeCompleted = this.konamiCode.every((codeKey, index) => this.konamiBuffer[index] === codeKey);

    if (codeCompleted) {
      this.showKonamiThanks = true;
      this.konamiBuffer = [];
    }
  }

  closeKonamiThanks(): void {
    this.showKonamiThanks = false;
  }

  // Funcion para expandir el recuadro de Analysis Options
  toggleDialogExpand() {
    this.isExpandedDialog = !this.isExpandedDialog;
  }

  // Cambio de icono segun sea seleccionado blanco o negro
  iconUrls: { [key in MenuItem]: { default: string; selected: string } } = {
    summary: {
      default: './assets/images/summary-on-icon.svg',
      selected: './assets/images/black_icons/summary-on-icon.svg'
    },
    statistics: {
      default: './assets/images/statistics-icon.svg',
      selected: './assets/images/black_icons/statistics-icon.svg'
    },
    readability: {
      default: './assets/images/readability-icon.svg',
      selected: './assets/images/readability-icon-on.svg'
    },
    errors: {
      default: './assets/images/errors-icon.svg',
      selected: './assets/images/black_icons/errors-icon.svg'
    },
    lexicalDiversity: {
      default: './assets/images/lexical-diversity-icon.svg',
      selected: './assets/images/black_icons/lexical-diversity-icon.svg'
    },
    tagger: {
      default: './assets/images/tagger-icon.svg',
      selected: './assets/images/black_icons/tagger-icon.svg'
    },
    kvl: {
      default: './assets/images/kvl-icon.svg',
      selected: './assets/images/black_icons/kvl-icon.svg'
    },
    evp: {
      default: './assets/images/kvl-icon.svg',
      selected: './assets/images/black_icons/kvl-icon.svg'
    },
    coca: {
      default: './assets/images/kvl-icon.svg',
      selected: './assets/images/black_icons/kvl-icon.svg'
    },
    awl: {
      default: './assets/images/kvl-icon.svg',
      selected: './assets/images/black_icons/kvl-icon.svg'
    },
    metadiscourse: {
      default: './assets/images/metadiscourse-icon.svg',
      selected: './assets/images/black_icons/metadiscourse-icon.svg'
    },
    scorecard: {
      default: './assets/images/scorecard-icon.svg',
      selected: './assets/images/black_icons/scorecard-icon.svg'
    },
    dashboard: {
      default: '',
      selected: ''
    },
    profile: {
      default: '',
      selected: ''
    },
    apiplan: {
      default: '',
      selected: ''
    },
    summaryfree: {
      default: './assets/images/summary-on-icon.svg',
      selected: './assets/images/black_icons/summary-on-icon.svg'
    },
    statisticsfree: {
      default: './assets/images/statistics-icon.svg',
      selected: './assets/images/black_icons/statistics-icon.svg'
    },
    readabilityfree: {
      default: './assets/images/readability-icon.svg',
      selected: './assets/images/readability-icon-on.svg'
    },
    errorsfree: {
      default: './assets/images/errors-icon.svg',
      selected: './assets/images/black_icons/errors-icon.svg'
    },
    lexicalfree: {
      default: './assets/images/lexical-diversity-icon.svg',
      selected: './assets/images/black_icons/lexical-diversity-icon.svg'
    },
    taggerfree: {
      default: './assets/images/tagger-icon.svg',
      selected: './assets/images/black_icons/tagger-icon.svg'
    },
    scorecardfree: {
      default: './assets/images/scorecard-icon.svg',
      selected: './assets/images/black_icons/scorecard-icon.svg'
    },
    evpfree: {
      default: './assets/images/kvl-icon.svg',
      selected: './assets/images/black_icons/kvl-icon.svg'
    },
    kvlfree: {
      default: './assets/images/kvl-icon.svg',
      selected: './assets/images/black_icons/kvl-icon.svg'
    },
    cocafree: {
      default: './assets/images/kvl-icon.svg',
      selected: './assets/images/black_icons/kvl-icon.svg'
    },
    awlfree: {
      default: './assets/images/kvl-icon.svg',
      selected: './assets/images/black_icons/kvl-icon.svg'
    },
    metadiscoursefree: {
      default: './assets/images/metadiscourse-icon.svg',
      selected: './assets/images/black_icons/metadiscourse-icon.svg'
    },
  };
  

  iconUrlsBlocked: { [key in MenuItem]: { default: string; selected: string } } = {
    summary: {
      default: '',
      selected: ''
    },
    statistics: {
      default: '',
      selected: ''
    },
    readability: {
      default: '',
      selected: ''
    },
    errors: {
      default: '',
      selected: ''
    },
    lexicalDiversity: {
      default: '',
      selected: ''
    },
    tagger: {
      default: '',
      selected: ''
    },
    kvl: {
      default: '',
      selected: ''
    },
    evp: {
      default: '',
      selected: ''
    },
    coca: {
      default: '',
      selected: ''
    },
    awl: {
      default: '',
      selected: ''
    },
    metadiscourse: {
      default: '',
      selected: ''
    },
    scorecard: {
      default: '',
      selected: ''
    },
    dashboard: {
      default: '',
      selected: ''
    },
    profile: {
      default: '',
      selected: ''
    },
    apiplan: {
      default: '',
      selected: ''
    },
    summaryfree: {
      default: '',
      selected: ''
    },
    statisticsfree: {
      default: '',
      selected: ''
    },
    readabilityfree: {
      default: '',
      selected: ''
    },
    errorsfree: {
      default: '',
      selected: ''
    },
    lexicalfree: {
      default: '',
      selected: ''
    },
    taggerfree: {
      default: '',
      selected: ''
    },
    evpfree: {
      default: './assets/images/blocked-icon.svg',
      selected: './assets/images/black_icons/blocked-icon.svg'
    },
    kvlfree: {
      default: '',
      selected: ''
    },
    cocafree: {
      default: '',
      selected: ''
    },
    awlfree: {
      default: './assets/images/blocked-icon.svg',
      selected: './assets/images/black_icons/blocked-icon.svg'
    },
    scorecardfree: {
      default: './assets/images/blocked-icon.svg',
      selected: './assets/images/black_icons/blocked-icon.svg'
    },
    metadiscoursefree: {
      default: './assets/images/blocked-icon.svg',
      selected: './assets/images/black_icons/blocked-icon.svg'
    },
   
  };

  //Funcion que al seleccionar alguna pestaña deshabilita el mat-slide-toggle de text-box
  isDisabled(): boolean {
    return ['readability', 'lexicalDiversity', 'metadiscourse', 'scorecard','errors','readabilityfree', 'lexicalfree', 'metadiscoursefree', 'scorecardfree','errorsfree'].includes(this.selectedMenuItem);
  }

  //Funcion que trae verdadero o falso de las pestañas de otros componentes
  ontextItemSelected(isSelected: boolean) {
    this.isTextBoxDisabled = isSelected;
  }

  //Funciones que valida si fue seleccionada alguna pestaña
  selectMenuItem(menuItem: string) {
    if (this.Disabled() && (menuItem === 'readability' || menuItem === 'lexicalDiversity' || menuItem === 'readabilityfree' || menuItem === 'lexicalfree')) {
      return; // No hace nada si está en modo Simple y se intenta seleccionar 'readability' o 'lexicalDiversity'
    }
    this.selectedMenuItem = menuItem;
    
    if(menuItem === 'dashboard' || menuItem === 'profile'){
      sessionStorage.removeItem("stay_in_same_page")
      sessionStorage.removeItem(this.newAnalysisReturnMenuKey)
      // this.proyectoService.updateBanderaLimpiarTexto(true)  //Prueba para limpiar Texto por limite de palabras, (No exitosa)
    }
    this.isTextBoxDisabled = this.isDisabled();
    if(menuItem !== 'apiplan'){
      this.toggleContent();
    }
    
    this.checkProjects();
    // Llamar al servicio para limpiar el marcado
    this.proyectoService.updateEditEye(false);
    this.proyectoService.terminarEdicionErrores(this.http);
    this.proyectoService.showEditEye(false);
    this.analysisService.limpiarMarcado();
  }

  private getDefaultAnalysisMenuItem(): string {
    return this.isLogin == true && this.isEVPFlag == true ? 'summary' : 'summaryfree';
  }

  private normalizeNewAnalysisReturnMenu(menuItem: string | null): string {
    if (!menuItem || !this.newAnalysisReturnableMenus.has(menuItem)) {
      return this.getDefaultAnalysisMenuItem();
    }

    if (this.isLogin == true && this.isEVPFlag == true && menuItem === 'summaryfree') {
      return 'summary';
    }

    if ((this.isLogin != true || this.isEVPFlag != true) && menuItem === 'summary') {
      return 'summaryfree';
    }

    return menuItem;
  }

  private rememberNewAnalysisReturnMenu(): void {
    sessionStorage.setItem(
      this.newAnalysisReturnMenuKey,
      this.normalizeNewAnalysisReturnMenu(this.selectedMenuItem)
    );
  }

  private restoreNewAnalysisReturnMenu(): void {
    const storedMenuItem = sessionStorage.getItem(this.newAnalysisReturnMenuKey);
    this.selectedMenuItem = this.normalizeNewAnalysisReturnMenu(storedMenuItem);
    this.isTextBoxDisabled = this.isDisabled();
  }

  isSelected(menuItem: MenuItem): boolean {
    return this.selectedMenuItem === menuItem;
  }

  //Funcion para traer el icono
  getIconUrl(menuItem: MenuItem): string {
    return this.isSelected(menuItem) ? this.iconUrls[menuItem].selected : this.iconUrls[menuItem].default;
  }

  //Funcion para traer el icono
  getIconUrlBlocked(menuItem: MenuItem): string {
  return this.isSelected(menuItem) ? this.iconUrlsBlocked[menuItem].selected : this.iconUrlsBlocked[menuItem].default;
  }

  checkedActionRea() {
    if (this.checked) {
      this.selectMenuItem('readability');
    }
  }

  checkedActionReafree() {
    if (this.checked) {
      this.selectMenuItem('readabilityfree');
    }
  }

  checkedActionErrors() {
    if (this.checked) {
      this.selectMenuItem('errors');
    }
  }

  checkedActionErrorsfree() {
    if (this.checked) {
      this.selectMenuItem('errorsfree');
    }
  }

  checkedActionLexical() {
    if (this.checked) {
      this.selectMenuItem('lexicalDiversity');
    }
  }

  checkedActionLexicalfree() {
    if (this.checked) {
      this.selectMenuItem('lexicalfree');
    }
  }

  checkedActionMetafree() {
    if (this.checked) {
      this.selectMenuItem('metadiscoursefree');
    }
  }

  checkedActionMeta() {
    if (this.checked) {
      this.selectMenuItem('metadiscourse');
    }
  }

  checkedActionScore() {
    if (this.checked) {
      this.selectMenuItem('scorecard');
    }
  }

  checkedActionScorefree() {
    if (this.checked) {
      this.selectMenuItem('scorecardfree');
    }
  }

  logOut(){
    this.proyectoService.clearKeysSessionStorage();
    this.proyectoService.clearProjectData();
    localStorage.removeItem("text-inspector-django-token");
    localStorage.removeItem("text-inspector-django-roles");
    localStorage.removeItem("Limit_words");
    localStorage.removeItem("OrganisationSize");
    localStorage.removeItem("text_UID");
    sessionStorage.removeItem("Proyectos");
    sessionStorage.removeItem("WordLists");
    this.isLogin = false;
    this.selectedMenuItem = 'summaryfree';
    this.valueM = false;
    this.isEVPFlag = false;
    sessionStorage.removeItem("stay_in_same_page")
    sessionStorage.removeItem(this.newAnalysisReturnMenuKey)
    this.isCreatingProject = false;
    this.proyectoService.updateDisableCreatingProjectAnalysis(false);
    this.proyectoService.updateEditEye(false);
    this.proyectoService.terminarEdicionErrores(this.http);
    this.proyectoService.showEditEye(false);
    setTimeout(() => {
      if(sessionStorage.getItem("id_project")){
        this.newAnalysis = false;
      }else{
        this.fisrtProject = true
        this.newAnalysis = true;
      }
    }, 1200);
   
  }

  // Revisa si 
  AnalizingProject(){

  }

  //Funciones que deshabilitan las pestañas si el mat-slide-toggle pasa a "Simple Mode"
  Disabled(): boolean {
    return !this.checked;
  }

  onCheckedChange(checked: boolean) {
    this.checked = checked;
  }

  isScreenLarge: boolean = true;
  isLoading: boolean = true; 
  showLeftPanel: boolean = true;
  showRightPanel: boolean = true;
  showContent: boolean = false;
  public userObject = null;
  private token_perl;
  // public text_data = {text:""};

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private analysisService: AnalysisServiceService,
    private http:HttpClient,
    public fachada: FacadeService,
    private dialog: MatDialog,
    public proyectoService: ProyectosService,
    private userService:UsuarioService,
    private router: Router,
    private route: ActivatedRoute) {
      this.version = "v" + environment.version
    }

    openTooltipModal(event: MouseEvent): void {
      const dialogConfig = new MatDialogConfig();
  
      dialogConfig.position = {
        top: `${event.clientY - 30}px`,
        left: `${event.clientX + 20}px` 
      };
      dialogConfig.panelClass = 'custom-tooltip-modal'; 
      dialogConfig.hasBackdrop = false; 
      dialogConfig.autoFocus = false;
  
      this.dialog.open(BlockedModalComponent, dialogConfig);
    }
  
    closeTooltipModal(): void {
      this.dialog.closeAll();
    }

    openTooltipModalMobile(event: MouseEvent): void {
      const dialogConfig = new MatDialogConfig();
    
      dialogConfig.position = {
        top: `${event.clientY - 30}px`,
        left: `${event.clientX - 200}px`
      };
      dialogConfig.panelClass = 'custom-tooltip-modal';
      dialogConfig.hasBackdrop = false;
      dialogConfig.autoFocus = false;
    
      const dialogRef = this.dialog.open(BlockedModalComponent, dialogConfig);
    
      // Cierra el modal automáticamente después de 2 segundos
      setTimeout(() => {
        dialogRef.close();
      }, 2000);
    }
    

    disableButtonOfTextbox: boolean = false;

  ngOnInit() {  
    // localStorage.setItem("text-inspector-django-roles","user")
    // localStorage.setItem("text-inspector-django-token","e8a0498b2b94573eccf0c99fc8e13150e2bd3b46")
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }
    let same_page = sessionStorage.getItem('stay_in_same_page');
      if(same_page){
       this.newAnalysis = true;
    }


  //   setInterval(() => {
  //   // Solo entra si todavía NO se le asignó un valor
  //   if (this.isPrincipalDocument === undefined) {
  //     const projectRaw = sessionStorage.getItem("analysis_op");
  //     if (projectRaw) {
  //       this.checkPrincipalDocument();
  //     }
  //   }
  // }, 2 * 1000); // 2 segundos
    

    this.wordsLimit = localStorage.getItem("Limit_words")

    
    // this.showModalProyect();
    this.inituser().then(() => {
      // Una vez que todo esté cargado, ocultamos el loader
      // console.log(":::EVPFALG IS: ", this.isEVPFlag)
      this.proyectLoaded();
      this.isLoading = false;
    });
    this.checkTextUID();
    this.checkProjects();
    // Funcion para saber si el tipo de Ingles es British o American
    this.analysisService.currentEnglishType.subscribe(type => {
      this.englishType = type;
    });
    this.proyectoService.valueM$.subscribe(state => {
      this.valueM = state;
    });

    this.proyectoService.limitOfProjects$.subscribe(state => {
       this.checkProjects();
    });

    this.proyectoService.limitOfWords$.subscribe(state => {
      if(state){
        this.valueLimitWords = true;
        setTimeout(() => {
          this.valueLimitWords = false;
        }, 3000);
      }
    });

    
    this.proyectoService.isEditCategory$.subscribe(state => {
      if(state){
        this.valueEditCategory = true;
        setTimeout(() => {
          this.valueEditCategory = false;
        }, 3000);
      }
    });

    this.proyectoService.callUpdateApiPage$.subscribe(state => {
      if(state){
        this.selectMenuItem('apiplan');
      }
    });

    this.proyectoService.profilePage$.subscribe(state => {
      if(state){
        this.selectedMenuItem ='profile';
      }
    });

     this.proyectoService.valueEditCategory$.subscribe(state => {
      if(state !== ""){
        this.stringEditCategory = state;
      }
    });

    this.proyectoService.deleteSameProjectOfStorage$.subscribe(state => {
      if(state){
        this.textUID = null;
        this.showBdelete = false;
     }
    });
    

     this.proyectoService.valueCreate$.subscribe(state => {
        this.openSaveDialog();
    });

    this.proyectoService.creatingProject$.subscribe(state => {
        this.isCreatingProject = state;
    });

    this.proyectoService.loaderAnalyzing$.subscribe(state => {
        this.isTextInputDisabled = state;
    });
    // let guardar = "2525d82dac665a1cd1e0e4a4c3f1d3cdf372f7f9"
    this.checkButtonFile();
    this.proyectoService.banderaF$.subscribe(bandera => {
      this.checkButtonFile();
    });

    this.proyectoService.banderaLimpiarTexto$.subscribe(state =>{ //Para impedir lo del limite de texto (No exitosa)
      if(state){
        this.disableButtonOfTextbox = true;
      }else{
        this.disableButtonOfTextbox = false;
      }
    })

    this.proyectoService.limitProfileUsers$.subscribe(state =>{ //Para impedir lo del limite de texto (No exitosa)
      if(state){
        this.valueLimitProfileUsers = true;
        setTimeout(() => {
          this.valueLimitProfileUsers = false;
        }, 3000);
      }
    })

    this.proyectoService.messageProfileUsers$.subscribe(message =>{ //Para impedir lo del limite de texto (No exitosa)
      if(message){
        this.messageProfileOrg = message;
        this.valueMessageProfileOrg = true;
        setTimeout(() => {
          this.valueMessageProfileOrg = false;
        }, 3000);
      }
    })
    
    
  }

  ngAfterViewInit() {
    
    this.showModalProyect();
  }

  handleClick(menu: string): void {
  if (this.isCreatingProject) {
    return; // Ignora el clic
  }
  this.selectMenuItem(menu);
}

handleClick2(menu: string): void {
  if (this.isCreatingProject || this.Disabled()) {
    return; // Ignora el click
  }
  if (this.checked) {
    this.selectMenuItem(menu);
  }
}

handleClick3(menu: string): void {
  if (this.isCreatingProject) {
    return; // Ignora el click
  }
  if (this.checked) {
    this.selectMenuItem(menu);
  }
}


  checkButtonFile(){
    let text_UID = sessionStorage.getItem('id_project');
        if (text_UID) {
            this.textFile = "Clone Project";
            this.showBdelete = true;
            this.newAnalysis = false;
        } else {
            this.textFile = "Save Project";
            this.showBdelete = false;
        }
  }
  async inituser(){
    // localStorage.setItem("text-inspector-django-token", "9bdf7f4b626249e95492018035d9d2f761dc2f36")
    // localStorage.setItem("text-inspector-django-roles", "admin,user")
    const searchParams = new URLSearchParams(window.location.search);
    const t = searchParams.get('t') ?? '';
    const transaction = searchParams.get('transaction') ?? '';
    const project = searchParams.get('workflow');
    const af = searchParams.get('af') ?? '';
    let id_sub_temp = "";
    this.token_perl = t;
    //Vamos a revisar si llega un analisis gratuito
    if (project != "" && project != undefined && project != null){
      this.logOut()
      this.newAnalysis = false;
      this.token_perl = ""; // Ignoramos el Token de PERL si es que llegan los 2 al mismo tiempo
      this.proyectoService.getinfo(this.http, project);
      // sessionStorage.setItem("id_project",)
      //sessionStorage.setItem("text_UID",project)
    } 
    if(!localStorage.getItem("text-inspector-django-token") || !localStorage.getItem("text-inspector-django-roles")){
      if (this.token_perl == ""){
        this.logOut()
      }else{
        // this.token_perl = this.token_perl.slice(2)
        console.log("Tengo un token de PERL, vamos a realizar el proceso de verificación")
        let django_response = null;
        try {
          django_response = await this.fachada.verificarLoginConPerl(this.http, this.token_perl);
        } catch (error) { 
        }
        if (django_response){
          localStorage.setItem("text-inspector-django-token", django_response["token"])
          try {
            console.log("Actualizamos info del usuario DJANGO TOKEN 1")
            await this.userService.getinfo(this.http)
            let response2 = await this.fachada.getLoginUser(this.http);
            console.log("USUARIO", response2);
            localStorage.setItem("text_UID", response2.text_UID);
            this.savePaymentFromLoginResponse(response2);
            localStorage.setItem("name_subs", response2.subscription.name);
            const role = response2.roles;
            localStorage.setItem("text-inspector-django-roles",role)
            this.isEVPFlag = response2?.subscription?.beneficios?.some(b => b?._type === "EVP") ?? false; // Verifica si tiene acceso al EVP
            id_sub_temp = django_response["plan_text_id"];
          } catch (error) {
            console.log("No se pudo recuperar la info del usuario")
          }
          this.userObject = this.userService.getdata()
          for (let index = 0; index < this.userObject.subscription.beneficios.length; index++) {
            const element = this.userObject.subscription.beneficios[index];
            if (element._type == "WordCount"){
              localStorage.setItem("Limit_words",element.word_count)
            }
            if (element._type == "OrganisationSize"){
              localStorage.setItem("OrganisationSize",element.user_count)
            }
          }
          // localStorage.setItem("Limit_words",this.userObject.subscription.beneficios[0].word_count)
        }else{
          console.log("No es un token valido")
          this.logOut()
        }
      }
    }else{
      if (this.token_perl == ""){
         console.log("Token de PERL Vacio, se usa Django")
        try {
            console.log("Actualizamos info del usuario SIN PASAR TOKEN")
            await this.userService.getinfo(this.http)
            let response2 = await this.fachada.getLoginUser(this.http);
            console.log("USUARIO", response2);
            localStorage.setItem("text_UID", response2.text_UID);
            this.savePaymentFromLoginResponse(response2);
            localStorage.setItem("name_subs", response2.subscription.name);
            const role = response2.roles;
            console.log(role)
            localStorage.setItem("text-inspector-django-roles",role)
            this.isEVPFlag = response2?.subscription?.beneficios?.some(b => b?._type === "EVP") ?? false; // Verifica si tiene acceso al EVP
          } catch (error) {
            console.log("No se pudo recuperar la info del usuario")
          }
          this.userObject = this.userService.getdata()
          for (let index = 0; index < this.userObject.subscription.beneficios.length; index++) {
            const element = this.userObject.subscription.beneficios[index];
            if (element._type == "WordCount"){
              localStorage.setItem("Limit_words",element.word_count)
            }
            if (element._type == "OrganisationSize"){
              localStorage.setItem("OrganisationSize",element.user_count)
            }
          }
          //localStorage.setItem("Limit_words",this.userObject.subscription.beneficios[0].word_count)
      }else{
        // this.token_perl = this.token_perl.slice(2)
        // console.log("Tengo un token de PERL, vamos a realizar el proceso de verificación")
        let django_response = null;
        try {
          django_response = await this.fachada.verificarLoginConPerl(this.http, this.token_perl);
        } catch (error) { 
          }
          if (django_response){
            localStorage.setItem("text-inspector-django-token", django_response["token"])
            try {
              console.log("Actualizamos info del usuario")
              await this.userService.getinfo(this.http)
              let response2 = await this.fachada.getLoginUser(this.http);
              this.savePaymentFromLoginResponse(response2);
              localStorage.setItem("name_subs", response2.subscription.name);
              console.log("USUARIO", response2);
              localStorage.setItem("text_UID", response2.text_UID);
              const role = response2.roles;
              console.log(role)
              localStorage.setItem("text-inspector-django-roles",role)
              this.isEVPFlag = response2?.subscription?.beneficios?.some(b => b?._type === "EVP") ?? false; // Verifica si tiene acceso al EVP
            } catch (error) {
              console.log("No se pudo recuperar la info del usuario")
            }
            this.userObject = this.userService.getdata()
            for (let index = 0; index < this.userObject.subscription.beneficios.length; index++) {
              const element = this.userObject.subscription.beneficios[index];
              if (element._type == "WordCount"){
                localStorage.setItem("Limit_words",element.word_count)
              }
              if (element._type == "OrganisationSize"){
                localStorage.setItem("OrganisationSize",element.user_count)
              }
            }
            //localStorage.setItem("Limit_words",this.userObject.subscription.beneficios[0].word_count)
          }else{
            console.log("Token de PERL no Valido, se usa Django")
            try {
                console.log("Actualizamos info del usuario TOKEN de DJANGO")
                await this.userService.getinfo(this.http)
                let response2 = await this.fachada.getLoginUser(this.http);
                console.log("USUARIO", response2);
                localStorage.setItem("text_UID", response2.text_UID);
                this.savePaymentFromLoginResponse(response2);
                localStorage.setItem("name_subs", response2.subscription.name);
                const role = response2.roles;
                console.log(role)
                localStorage.setItem("text-inspector-django-roles",role)
                this.isEVPFlag = response2?.subscription?.beneficios?.some(b => b?._type === "EVP") ?? false; // Verifica si tiene acceso al EVP
              } catch (error) {
                console.log("No se pudo recuperar la info del usuario")
              }
              this.userObject = this.userService.getdata()
              for (let index = 0; index < this.userObject.subscription.beneficios.length; index++) {
                const element = this.userObject.subscription.beneficios[index];
                if (element._type == "WordCount"){
                  localStorage.setItem("Limit_words",element.word_count)
                }
                if (element._type == "OrganisationSize"){
                  localStorage.setItem("OrganisationSize",element.user_count)
                }
              }
              //localStorage.setItem("Limit_words",this.userObject.subscription.beneficios[0].word_count)
          }
      }
    }

    // DESCOMENTAR CODIGO PARA API FLOW
    if (transaction === "1") {
      this.showPaymentModal = true;
    } else {
      this.showPaymentModal = false;
    }

    if (af === "1"){
      console.log("Vamos a actualizar el usuario de V1 para que tenga el plan 100")
      // por seguridad volvemos a llamar la verificación y actualice los datos una vez más
      // this.fachada.editInfoUser(this.http, id_sub_temp, "100",[],"");
      localStorage.setItem("name_subs", "API calls 200 per month - Yearly");
      await this.fachada.verificarLoginConPerl(this.http, this.token_perl);
      await this.userService.getinfo(this.http)

    }

    window.history.replaceState(null, "", window.location.pathname);  
  }

   closeModalApi() {
    this.showPaymentModal = false;
  }

  goToDocs() {
    window.location.href = 'https://textinspector.com/wiki/docs.html';
  }

  goToAccount() {
    this.closeModalApi();
    this.selectMenuItem('profile');
  }

  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }

  toggleContent() {
    this.showContent = !this.showContent;
  }
  toggleLeftPanel() {
    this.showLeftPanel = !this.showLeftPanel;
  }

  toggleRightPanel() {
    this.showRightPanel = !this.showRightPanel;
  }
  //Valores para expandir cada Cuadro
  public isExpanded: ExpandedState = {
    TEXT: false,
    RESULTS: false
  };

  private savePaymentFromLoginResponse(response: any): void {
    if (response?.payment) {
      localStorage.setItem("payment", JSON.stringify(response.payment));
      return;
    }

    const stripePayment = this.getStripePaymentFromLoginResponse(response);
    if (stripePayment) {
      localStorage.setItem("payment", JSON.stringify(stripePayment));
      return;
    }

    const subscriptionStart = this.parseSubscriptionPaymentDate(response?.subscription?.start);
    const subscriptionEnd = this.parseSubscriptionPaymentDate(response?.subscription?.end);

    if (!subscriptionStart || !subscriptionEnd) {
      localStorage.removeItem("payment");
      return;
    }

    localStorage.setItem("payment", JSON.stringify({
      payment: response?.subscription?.payment ?? '',
      start: Math.floor(subscriptionStart.getTime() / 1000),
      end: Math.floor(subscriptionEnd.getTime() / 1000),
      status: response?.subscription?.status ?? '',
      ok: response?.subscription?.ok ?? null
    }));
  }

  private getStripePaymentFromLoginResponse(response: any): any | null {
    const stripeInfo = this.parseStripeInfo(response?.stripe_info);
    const stripeData = stripeInfo?.data;
    const firstStripeItem = Array.isArray(stripeData) && stripeData.length > 0 ? stripeData[0] : null;

    if (!firstStripeItem?.current_period_start || !firstStripeItem?.current_period_end) {
      return null;
    }

    return {
      payment: 'Stripe',
      start: this.normalizeUnixTimestamp(firstStripeItem.current_period_start),
      end: this.normalizeUnixTimestamp(firstStripeItem.current_period_end),
      status: response?.subscription?.status ?? '',
      ok: response?.subscription?.ok ?? null
    };
  }

  private parseStripeInfo(stripeInfo: any): any | null {
    if (!stripeInfo) return null;
    if (typeof stripeInfo !== 'string') return stripeInfo;

    try {
      return JSON.parse(stripeInfo);
    } catch (error) {
      return null;
    }
  }

  private normalizeUnixTimestamp(value: number | string): number {
    const timestamp = Number(value);
    return timestamp > 9999999999 ? Math.floor(timestamp / 1000) : timestamp;
  }

  private parseSubscriptionPaymentDate(value: string | null | undefined): Date | null {
    if (!value) return null;

    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})[:T ](\d{2}):(\d{2}):(\d{2})$/);
    if (!match) return null;

    const date = new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4]),
      Number(match[5]),
      Number(match[6])
    );

    return Number.isNaN(date.getTime()) ? null : date;
  }

   //Funcion para expandir cada cuadro
   toggleExpand(identifier: string) {
    this.isExpanded[identifier] = !this.isExpanded[identifier];
    // Llamar al servicio para limpiar el marcado
    // Verificar si TEXT es false antes de limpiar el marcado
    if (this.isExpanded['TEXT']) {
      this.analysisService.limpiarMarcado();
      this.proyectoService.cleanEyes();
    }
  }

  editProyect(){
    if(this.isLogin == true && this.isEVPFlag == true){
      this.selectedMenuItem="summary";
    }else{
      this.selectedMenuItem="summaryfree";
    }
    this.newAnalysis=false;
  }

  isNewAnalysis(){

    const projects = sessionStorage.getItem("Proyectos");
      if (!projects) return;

    this.checkProjects();
    if(!this.isThereManyProjects){
      this.rememberNewAnalysisReturnMenu();
      this.proyectoService.clearKeysSessionStorage();
      this.proyectoService.clearProjectData();
      this.checkTextUID();
      this.fisrtProject = true;
      this.proyectoService.triggerTextBoxRefresh();
      this.showModalProyect();
      this.textFile = "Save Project"
      this.showBdelete = false;
      sessionStorage.setItem("stay_in_same_page", "true")
      window.location.reload();
    }else{
      this.proyectoService.updateDisablelimitOfProjectsProfile(true);
         this.valueLimitProjects = true;
      setTimeout(() => {
        this.valueLimitProjects = false;
      }, 4000);
      
    
    }
   
  }

  clearSessionStorage(){
    this.proyectoService.clearKeysSessionStorage();
    this.proyectoService.clearProjectData();
    this.proyectoService.cleanTextbyLogin();
    
  }

  proyectLoaded(){
    if(this.textUID){
      let id_project = sessionStorage.getItem('id_project');
      
      this.proyectoService.getinfo(this.http, id_project);
      this.newAnalysis=false;
      if(sessionStorage.getItem('stay_in_same_page')){
        this.restoreNewAnalysisReturnMenu();
      }else if(this.isLogin == true && this.isEVPFlag == true){
        this.selectedMenuItem="summary";
      }else{
        console.log("::::BLOQUEO DE SUMMARY::::::PROYECTLOADED::::::: Cambie a SummaryFREE")
        this.selectedMenuItem="summaryfree";
      }
      
    }else{
      let same_page = sessionStorage.getItem('stay_in_same_page');
      if(same_page){
        this.restoreNewAnalysisReturnMenu();
    }
  }
    
  }

  checkTextUID() { 
    try {
      this.textUID = sessionStorage.getItem('text_UID');
      console.log("SESSION STORAGE---------------------"+this.textUID);
    } catch (error) {
      console.log("No se puede acceder al SessionStorage")
    }
  }

  getCocaText(): string {
    return this.englishType === 'british' ? 'BNC' : 'COCA';
  }

  messageSaveProject(){
    let texto = document.getElementById("textArea") as HTMLInputElement
      if(texto === null || this.selectedMenuItem === "dashboard"){
         this.showModalExport2 = true;
         this.showModalExportMobile2 = true;
        setTimeout(() => {
          this.showModalExport2 = false;
          this.showModalExportMobile2 = false;
        }, 3000);
      }
  }

  isThereManyProjects: boolean;

  checkProjects(){
    let totalProyectos = Number(sessionStorage.getItem("Proyectos"));

      if (totalProyectos >= 10) {
          this.isThereManyProjects = true;
      }else{
          this.isThereManyProjects = false;
      }
  }

  // isPrincipalDocument: boolean | undefined;

  // checkPrincipalDocument(){
  //   const projectRaw = sessionStorage.getItem("analysis_op");
  //     if (!projectRaw) return;

  //     try {
  //       const project = JSON.parse(projectRaw);
  //       this.isPrincipalDocument = project.principal;
  //     } catch (error) {
  //       console.error("Error parsing analysis_op JSON:", error);
  //       this.isPrincipalDocument = false;
  //     }
  // }

async openSaveDialog() {
  let totalProyectos = Number(sessionStorage.getItem("Proyectos"));

  // Si quieres aplicar una condición cuando hay más de 10
  if (totalProyectos >= 10) {
    if (!sessionStorage.getItem("id_project")) {
      this.valueLimitProjects = true;
      setTimeout(() => {
        this.valueLimitProjects = false;
      }, 4000);
    }
  } else {
    this.valueLimitProjects = false;

    this.analysisService.currentAnalysisMode.subscribe(mode => {
      this.currentAnalysisMode = mode;
    });

    this.analysisService.currentSplitCharacter.subscribe(character => {
      this.currentSplitCharacter = character;
    });

    let savecurrentEnglishType;
    this.analysisService.currentEnglishType.subscribe(character => {
      savecurrentEnglishType = character;
    });

    let savecurrentTarget;
    this.analysisService.currentTargetCEFR.subscribe(character => {
      savecurrentTarget = character;
    });

    let savewordlistselect;
    this.analysisService.currentWordlist.subscribe(value => {
      savewordlistselect = value;
    });

    let saveExcludeDigitsselect;
    this.analysisService.currentExcludeDigits.subscribe(value => {
      saveExcludeDigitsselect = value;
    });

    let saveUseKnownWordsselect;
    this.analysisService.currentUseKnownWords.subscribe(value => {
      saveUseKnownWordsselect = value;
    });

    let texto = document.getElementById("textArea") as HTMLInputElement;
    if (!texto.value || texto.value.trim() === "") {
      this.valueTM = true;
      setTimeout(() => {
        this.valueTM = false;
      }, 3000);
    } else {

      this.proyectoService.updateloaderCreatingProject(true);
      let json = {
        delimiter: this.currentSplitCharacter,
        split: "1",
        textmode: this.currentAnalysisMode,
        englishType: savecurrentEnglishType,
        target: savecurrentTarget,
        wordlist: savewordlistselect,
        excludeDigits: saveExcludeDigitsselect,
        useKnownWords: saveUseKnownWordsselect,
        matchPrhases: false
      };

      let data = { text: texto.value, config_json: json };

      try {
        let respuesta = await this.fachada.createProject(
          this.http,
          data,
          localStorage.getItem("text-inspector-django-token")
        );

        if (respuesta) {
          let totalProyectos = Number(sessionStorage.getItem("Proyectos"));
          sessionStorage.setItem("Proyectos", String(totalProyectos + 1));

          if (this.fisrtProject) {
            this.isCreatingProject = true;
            this.proyectoService.updateDisableCreatingProjectAnalysis(true);
          }

          this.fisrtProject = false;
          sessionStorage.setItem("id_project", respuesta.id_project);
          sessionStorage.setItem("text_UID", respuesta.text_UID);

          this.dialog.open(SaveConfirmationComponent, {
            width: "450px",
            height: "50px",
            position: { top: "40px" },
            backdropClass: "dialog-backdrop-transparent"
          });

          this.proyectoService.updateLimitOfDocuments(false);
          this.newAnalysis = false;

          // Emitir el evento de proyecto guardado
          this.proyectoService.proyectoGuardado();
          this.checkTextUID();
          this.proyectLoaded();
          this.checkButtonFile();
          this.checkProjects();
          sessionStorage.removeItem("stay_in_same_page");
          sessionStorage.removeItem(this.newAnalysisReturnMenuKey);

        } else {
          console.log("No se pudo crear el proyecto");
        }
      } catch (error: any) {
         if (
          (error?.error?.msg && error.error.msg.startsWith("A maximum")) ||
          error?.status === 406
        ) {
          console.error("Límite alcanzado:", error.error?.msg || error.message);
          this.proyectoService.updateLimitOfDocuments(true);

        } else {
          console.error("❌ Error desconocido:", error);
        }
        this.proyectoService.updateloaderCreatingProject(false);
      }
    }
  }
}






deleteProject() {
  const projectRaw = sessionStorage.getItem("analysis_op");
  if (!projectRaw) return;

  try {
    const project = JSON.parse(projectRaw);

    let id_project: number | null = null;
    let text_UID: string | null = null;

    // Caso 1: el proyecto principal está en el objeto raíz
    if (project.principal === true) {
      id_project = project.id_project;
      text_UID = project.text_UID;
    } 
    // Caso 2: el proyecto principal está dentro de related_projects
    else if (project.related_projects && Array.isArray(project.related_projects)) {
      const principalDoc = project.related_projects.find(p => p.principal === true);
      if (principalDoc) {
        id_project = principalDoc.id_project;
        text_UID = principalDoc.text_UID;
      }
    }

    if (id_project && text_UID) {
      const dialogRef = this.dialog.open(ProjectRemoveComponent, {
        data: {},
        backdropClass: 'dialog-backdrop-dark'
      });

      dialogRef.afterClosed().subscribe(async result => {
        if (result) {
         try {
            this.loaderClearServers = true;
            this.bloquearClicks()
            await this.proyectoService.setDeleteProyect(this.http, true, id_project!, text_UID!);

            let totalProyectos = Number(sessionStorage.getItem("Proyectos"));
            sessionStorage.setItem("Proyectos", String(totalProyectos - 1));

            window.location.reload();

          } catch (error) {
            console.error("Error al eliminar el proyecto:", error);
            this.loaderClearServers = false;
            this.desbloquearClicks()
          }
        }
      });
    } else {
      console.warn("No se encontró un documento principal en el JSON.");
      this.showModalProyect();
    }

  } catch (error) {
    console.error("Error al parsear analysis_op JSON:", error);
  }
}

// Bloquear
bloquearClicks() {
  document.addEventListener("click", this.stopClick, true);
}

stopClick(e: MouseEvent) {
  e.stopPropagation();
  e.preventDefault();
}

// Desbloquear
desbloquearClicks() {
  document.removeEventListener("click", this.stopClick, true);
}



  showModal = false; 
  showModalExport = false;
  noProyectModal = false;
  loadProyectModal = false;
  showModalExport2 = false; 
  showModalExportMobile = false; 
  showModalExportMobile2 = false; 

  showModalProyect() {
    this.checkTextUID();
    if (sessionStorage.getItem('text_UID')) {
      this.loadProyectModal = true;
      this.noProyectModal = false;
      setTimeout(() => {
        this.loadProyectModal = false;
      }, 2000);
    } else {
      this.noProyectModal = true;
      this.loadProyectModal = false;
      setTimeout(() => {
        this.noProyectModal = false;
      }, 2000);
    }
  }
  
  

  onMouseEnter() {
    if (this.Disabled()) {
      this.showModal = true;
    }
  }

  onMouseLeave() {
    this.showModal = false;
  }

  closeModal() {
    this.showModal = false;
  }

  showModalMobile = false;

  onTabClickMobile() {
    if (this.Disabled()) {
      this.showModalMobile = true;
      setTimeout(() => {
        this.showModalMobile = false;
      }, 3000); // Desaparece después de 2 segundos
    }
  }

  openGlobalExportDialog(): void {
    // Obtener text_UID del sessionStorage
    const text_UID = sessionStorage.getItem('text_UID');
    
    if (text_UID && text_UID !== '') {
  
      this.dialog.open(GlobalExportComponent, {
        hasBackdrop: false,
        closeOnNavigation: true, // Cierra el modal si navegas
        data: text_UID
      });
    } else {
      this.showModalExport = true;
      setTimeout(() => {
        this.showModalExport = false;
      }, 3000);
  
      this.showModalExportMobile = true;
      setTimeout(() => {
        this.showModalExportMobile = false;
      }, 3000);
    }
  }
  
  

}


